import { openapi_website_cms_removeMarket, Response200Type, decodeResponse200 } from 'src/api_openapi/generated/openapi_website_cms_removeMarket';
import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';

export type RemoveMarketType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Response200Type  => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface RemoveMarketParamsType {
    marketId: number
}

export const removeMarketFromFilter = {
    browser: {
        params: (params: RemoveMarketParamsType): ParamsFetchType<RemoveMarketParamsType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/remove-market',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/remove-market',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<RemoveMarketParamsType>): Promise<GenerateUrlApiType> => {

        const resp = await openapi_website_cms_removeMarket(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            id: params.req.body.marketId
        });

        return {
            passToBackend: false,
            status: resp.status,
            responseBody: resp.body
        };
    }
};
